import { useEffect } from 'react';

export default function Privacy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black pt-32 pb-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Política de Privacidad</h1>
                <div className="text-gray-300 space-y-6 leading-relaxed">

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">1. Recopilación de Datos</h2>
                        <p>Recopilamos únicamente la información necesaria para procesar su pedido: dirección de correo electrónico e información de pago (procesada por nuestros proveedores seguros). No conservamos sus datos bancarios.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">2. Uso de los Datos</h2>
                        <p>Sus datos se utilizan para:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Enviarle sus credenciales de inicio de sesión.</li>
                            <li>Brindarle soporte técnico.</li>
                            <li>Informarle sobre actualizaciones importantes del servicio.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">3. Protección de Datos</h2>
                        <p>Implementamos medidas de seguridad técnicas para proteger su información personal contra el acceso no autorizado. Sus datos nunca se venden a terceros.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">4. Cookies</h2>
                        <p>Nuestro sitio utiliza cookies esenciales para el funcionamiento del carrito de compras y el análisis anónimo del tráfico para mejorar su experiencia.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">5. Sus Derechos</h2>
                        <p>De acuerdo con el RGPD, usted tiene derecho a acceder, rectificar y eliminar sus datos. Para ejercer este derecho, contáctenos en support@tvsola.com.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
